// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".btn-favorite[data-v-2e3137f7]{align-items:center;background:#f7f7f7;border:.25px solid #000;display:flex;height:65px;justify-content:center;-webkit-text-decoration:none;text-decoration:none;width:126px}.btn-favorite[data-v-2e3137f7]:hover{background:#dbdbdb}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
